import {
  useEffect,
  useRef,
  MutableRefObject
} from 'react';

import { useGoogleInfoWindow } from './useGoogleInfoWindow';
import { useHereInfoWindow } from './useHereInfoWindow';
import { useDocumentListenerToCloseInfoWindow } from './useDocumentListenerToCloseInfoWindow';
import { useMapListenerToCloseInfoWindow } from './useMapListenerToCloseInfoWindow';
import { useMapContext } from 'entities/map';

import { GoogleMap, HereMap } from 'common/utils';
import {
  MapInfoWindowProps,
  RootElementRef
} from '../ui/MapInfoWindow/MapInfoWindow';

interface Props extends Pick<
  MapInfoWindowProps,
  'coordinates' | 'showCloseIcon'
> {
  rootRef: MutableRefObject<RootElementRef>;
}

interface Handlers {
  onClose: MapInfoWindowProps['onClose']
}

export const useUpdateInfoWindow = (
  {
    coordinates,
    rootRef,
    showCloseIcon,
  }: Props,
  {
    onClose
  }: Handlers
) => {
  const { map } = useMapContext();
  const infoWindowRef = useRef<any | null>(null);
  const googleInfoWindow = useGoogleInfoWindow(map);
  const hereInfoWindow = useHereInfoWindow(map, showCloseIcon, onClose);

  useDocumentListenerToCloseInfoWindow(infoWindowRef, onClose);
  useMapListenerToCloseInfoWindow(infoWindowRef, onClose);

  useEffect(() => {
    if (infoWindowRef.current) {
      infoWindowRef.current.hide();
    }

    if (coordinates && coordinates.length && map && rootRef.current) {
      if (map instanceof GoogleMap) {
        infoWindowRef.current = googleInfoWindow(coordinates, rootRef.current);
      }
      
      if (map instanceof HereMap) {
        infoWindowRef.current = hereInfoWindow(coordinates, rootRef.current);
      }
    }
  // eslint-disable-next-line
  }, [
    coordinates,
    map,
    infoWindowRef,
    googleInfoWindow,
    hereInfoWindow,
    rootRef,
    showCloseIcon
  ]);

  useEffect(() => () => {
    if (infoWindowRef.current) {
      infoWindowRef.current.hide();
    }
  }, []);
};
